import { Check } from 'lucide-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import { SignedInAvatar } from './SignedInAvatar'

export interface DemoVersion {
  name: string
  /** What the fleet has bought in this version. */
  active: string[]
}

/**
 * The signed-in user, with a switch for which version of the account is being
 * shown. The switch is scaffolding for the demo, not a thing the product would
 * have — hence its own labelled section at the bottom.
 */
export function ProfileMenu({
  versions,
  current,
  onChoose,
}: {
  versions: DemoVersion[]
  current: string
  onChoose: (name: string) => void
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger aria-label="Account" className="rounded-full">
        <SignedInAvatar />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="flex flex-col gap-0.5">
          <span className="text-ink text-xs font-medium">Jim Mitchell</span>
          <span className="text-ink-400 text-[10px] font-normal">jim@bluelinefreight.com</span>
        </DropdownMenuLabel>
        <DropdownMenuItem className="text-xs">Settings</DropdownMenuItem>
        <DropdownMenuItem className="text-xs">Sign out</DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-ink-400 text-[10px] font-normal">
          Demo — which version to show
        </DropdownMenuLabel>
        {versions.map((version) => (
          <DropdownMenuItem
            key={version.name}
            onSelect={() => onChoose(version.name)}
            className="justify-between gap-2 text-xs"
          >
            {version.name}
            <Check className={cn('text-brand-700 size-3.5', current !== version.name && 'invisible')} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
